import React, {useEffect, useState} from 'react';
import {useTheme} from "../../common/ProjectThemeProvider";
import {
    checkNullStr,
    createTimeout,
    focusFormIdElement,
    getCurrUrlParamValue,
    getJsonValue,
    isBoolTrue,
    isJsonValueTrue
} from "../../common/fusion-ui/utils/ReactUtils";
import {sendAdminRequest} from "../utils/AdminUtils";
import {printError, printLog,} from "../../common/CommonUtils";
import {useToast} from "../../common/fusion-ui/provider/ToastProvider";
import {useLocation, useNavigate} from "react-router-dom";
import {AdminModuleFieldsData, AdminModuleRouteUrls, AdminModules, AdminReqUrls, ShowViewType,} from "../config/AdminConfig";
import {CssVariant, Messages} from "../../common/fusion-ui/config/FusionConfig";
import {ThemedInput} from "../../common/components";
import {FormPageRoot} from "../components";
import {useInternetStatus} from "../../common/fusion-ui/hook";
import {UnderMaintenance, UnderMaintenanceMsg} from "../../common/CommonConfig";

const ParentCompany__AddEditFormPage = React.memo(({
                                                       updateOnly,
                                                       open,
                                                       onHide,
                                                       recordId,
                                                       showAs = ShowViewType.PAGE,
                                                       onSuccess,
                                                   }) => {
    const TAG = "ParentCompany__AddEditFormPage";

    const moduleName = AdminModules.ParentCompany;
    const mf = AdminModuleFieldsData[moduleName];
    const NAME_KEY = 'name';

    const theme = useTheme();
    const location = useLocation();
    const navigate = useNavigate();
    const {showToast, changeToastVariant} = useToast();
    const {isOnline, internetCheckingMsg} = useInternetStatus();
    // const {isScreenXs, isScreenSm, isScreenMd, isScreenResizing} = useScreenSize();

    const FOCUS_DELAY = 2000;

    const Fields = {
        updateRecordId: 'updateRecordId',

        isUpdateFormDataFetched: 'isUpdateFormDataFetched',

        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',

        submitBtn_AsLoading: 'submitBtn_AsLoading',
        submitBtn_disabled: 'submitBtn_disabled',

        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',
    };
    const [fieldsData, setFieldsData] = useState({});
    // const [formData, setFormData] = useState(ParentCompany__AddEditFormPage_FormData);
    const [formData, setFormData] = useState({});
    const [formFieldsMsgs, setFormFieldsMsgs] = useState({});

    useEffect(() => {
        if (!checkNullStr(getField(Fields.panelMsg)) && !isUpdateMode()) {
            updateField(Fields.isDataLoading, false);
            updateField(Fields.isDataFound, true);
        }

        log('useEffect.showAs:', showAs, 'recordId:', recordId);
        if (showAs == ShowViewType.PAGE) {
            if (isUpdateMode()) {
                const id = getCurrUrlParamValue('id');
                log('useEffect.showAs:', showAs, 'id:', id);
                fetchEditModeData(id);
            }
        } else {
            if (checkNullStr(recordId) && isUpdateMode()) {
                fetchEditModeData(recordId, false);
            }
        }
    }, [recordId, showAs, updateOnly]);

    return (<>
        <FormPageRoot
            tag={TAG}
            moduleName={moduleName}
            updateOnly={isUpdateMode()}
            isDataLoading={getField(Fields.isDataLoading)}
            isDataFound={getField(Fields.isDataFound)}
            dataLoadingMsg={getField(Fields.dataLoadingMsg)}
            open={open}
            animateChildren={false}
            onHide={() => {
                if (onHide) onHide();
                clearPanelData();
                if (showAs != ShowViewType.PAGE && !isUpdateMode()) {
                    updateField(Fields.dataLoadingMsg, '');
                    updateField(Fields.isDataFound, true);
                    updateField(Fields.isDataLoading, false);
                }
            }}
            md={showAs == ShowViewType.PAGE ? 5 : 5}
            showAs={showAs}
            panelMsg={getField(Fields.panelMsg)}
            panelMsgColor={getField(Fields.panelMsgColor)}
            isSubmitDisabled={isFieldTrue(Fields.submitBtn_disabled)}
            isSubmitLoading={isFieldTrue(Fields.submitBtn_AsLoading)}
            onSubmit={handleSubmit}
        >
            {/*name*/}
            <ThemedInput
                wrapperClassName={'w-100'}
                className={'w-100'}
                label={mf.name.title}
                placeholder={mf.name.title}
                id={mf.name.column}
                value={getFormField(mf.name)}
                msg={getFormFieldMsg(mf.name)}
                required={true}
                onChange={(e) => {
                    const value = e.target.value;//2024-04-19T15:34
                    updateFormField(mf.name, value);
                    updateFormFieldMsg(mf.name, '');
                    panelLog('');
                }}
            />
        </FormPageRoot>
    </>)

    function handleSubmit() {
        const fun = 'handleSubmit:';
        log(fun, 'formData:', formData);
        if (UnderMaintenance) {
            toast(UnderMaintenanceMsg, CssVariant.warning);
            return false;
        }
        if (!isOnline) {
            toast(internetCheckingMsg, CssVariant.warning);
            return false;
        }

        try {
            let allFieldsChecked = checkRequiredFields();
            // allFieldsChecked = false;//for checking
            if (allFieldsChecked) {
                updateField(Fields.submitBtn_AsLoading, true);
                updateField(Fields.submitBtn_disabled, true);
                panelLog(null);

                const REQUEST_OPTIONS = {
                    updateOnly: isUpdateMode(),
                    recordId: getField(Fields.updateRecordId),
                    formData: formData,
                };
                sendAdminRequest({
                    reqUrl: AdminReqUrls.admin__parentComp_addEditPage_submit_formData,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');

                        // updateField(Fields.submitBtn_disabled, false);//for testing only
                        if (success) {
                            toast(message, CssVariant.success);
                            if (showAs == ShowViewType.PAGE) {
                                redirectPage();
                            } else {
                                createTimeout(() => {
                                    clearPanelData();
                                }, 300);
                            }
                            if (onSuccess) onSuccess();
                        } else {
                            toast(message, CssVariant.danger);
                            updateField(Fields.submitBtn_disabled, false);
                        }
                        updateField(Fields.submitBtn_AsLoading, false);
                    }),
                    onError: ((error) => {
                        toast(Messages.saveError, CssVariant.danger);
                        updateField(Fields.submitBtn_AsLoading, false);
                        updateField(Fields.submitBtn_disabled, false);
                        logErr(fun, error);
                    }),
                });
            }
        } catch (error) {
            toast(Messages.saveError, CssVariant.danger);
            updateField(Fields.submitBtn_AsLoading, false);
            updateField(Fields.submitBtn_disabled, false);
            logErr(fun, error);
        }
    }

    async function fetchEditModeData(recordId, checkBefore = true) {
        const fun = 'fetchEditModeData:';
        try {
            log(fun, 'recordId:', recordId, 'isUpdateFormDataFetched:', isFieldTrue(Fields.isUpdateFormDataFetched));
            if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isUpdateFormDataFetched))) {
                updateField(Fields.isUpdateFormDataFetched, true);
                updateField(Fields.updateRecordId, recordId);
                if (checkNullStr(recordId)) {
                    updateField(Fields.isDataLoading, true);
                    updateField(Fields.dataLoadingMsg, "");

                    //send-request
                    const REQUEST_OPTIONS = {
                        recordId: recordId,
                    };
                    sendAdminRequest({
                        reqUrl: AdminReqUrls.admin__parentComp_fetchEditPageRecord,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: ((fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const fetchedFormData = getJsonValue(fetchedData, 'data', {});
                            const message = getJsonValue(fetchedData, 'message');
                            const success = isJsonValueTrue(fetchedData, 'success');

                            updateField(Fields.isDataFound, success);
                            if (success) {
                                // toast(message, CssVariant.success);
                                setFormData(fetchedFormData);
                            } else {
                                toast(message, CssVariant.danger);
                                updateField(Fields.dataLoadingMsg, "Invalid record id!");
                            }
                            updateField(Fields.isDataLoading, false);
                        }),
                        onError: ((error) => {
                            logErr(fun, error);
                            updateField(Fields.dataLoadingMsg, Messages.fetchError);
                            updateField(Fields.isDataFound, false);
                            updateField(Fields.isDataLoading, false);
                        }),
                    });
                } else {
                    updateField(Fields.dataLoadingMsg, 'Record-id not found!');
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.isDataLoading, false);
                }
            }
        } catch (error) {
            logErr(fun, error);
            updateField(Fields.dataLoadingMsg, Messages.fetchError);
            updateField(Fields.isDataFound, false);
            updateField(Fields.isDataLoading, false);
        }
    }

    function redirectPage() {
        createTimeout(() => {
            panelLog(`Redirecting you to the '${moduleName}' page now...`);
            createTimeout(() => {
                // window.location.href = AdminModuleRouteUrls[moduleName];
                navigate(AdminModuleRouteUrls[moduleName]);
            }, 2500);
        }, 500);
    }

    //======================Request Functions end=====================

    //======================Util Functions start=====================
    function checkRequiredFields() {
        const fun = 'checkRequiredFields:';
        const requiredFields = [
            mf.name,
        ];

        let verified = false;
        let colField = {};
        for (const field of requiredFields) {
            if (!checkNullStr(formData[field.column])) {
                colField = field;
                verified = false;
                break;
            } else {
                verified = true;
            }
        }
        if (!verified) {
            // log(fun, "!verified.colField:", colField, 'idToFocus:', colField.column);
            updateFormFieldMsg(colField, 'Required field');
            toast(`'${colField.title}' cannot be empty!`, CssVariant.danger);
            focusIdField(colField.column);
        }
        return verified;
    }

    function focusIdField(id, onlyFocus = false) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
    }


    function clearPanelData() {
        setFormFieldsMsgs({});
        setFormData({});
        setFieldsData({});
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function updateFormField(clmField, value, direct = false) {
        setFormData(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormField(clmField, defValue, direct = false) {
        return getJsonValue(formData, direct ? clmField : clmField.column, defValue);
    }

    function isFormFieldTrue(clmField, direct = false) {
        return isBoolTrue(getFormField(clmField, null, direct), true, true);
    }

    function updateFormFieldMsg(clmField, value, direct = false) {
        setFormFieldsMsgs(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormFieldMsg(clmField, defValue, direct = false) {
        return getJsonValue(formFieldsMsgs, direct ? clmField : clmField.column, defValue);
    }

    function isUpdateMode() {
        return isBoolTrue(updateOnly);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        if (text) log(...[text]);
        ;
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        if (text) log(...[text]);
        ;
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default ParentCompany__AddEditFormPage;
